import React, { useState } from 'react';
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    InputLabel,
    NativeSelect,
    useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const styles = {
    button: {
        margin: 1,
    },
    select: {
        mt: 2,
        ml: 1,
        mr: 1,
        width: '95%',
    },
    info: {
        mt: 2,
    },
};

export default function ChangePortfolioDialog(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [newPortfolioId, setNewPortfolioId] = useState(0);
    const portfolios = props.portfolios;
    const infoText = props.infoText;
    const processing = props.processing;
    const { t } = useTranslation();

    const cancel = () => {
        props.cancel();
    };
    const execute = () => {
        props.changePortfolio(newPortfolioId);
    };
    const handleChange = (event) => {
        setNewPortfolioId(parseInt(event.target.value));
    };

    return (
        <Dialog
            onClose={cancel}
            aria-labelledby="simple-dialog-title"
            open={props.open}
            fullWidth={true}
            maxWidth={'md'}
            fullScreen={fullScreen}>
            <DialogContent dividers>
                <FormControl sx={styles.select}>
                    <InputLabel id="customership-status-label">{t('general.moveToPortfolio')}</InputLabel>
                    <NativeSelect
                        required
                        labelid="portfolio-selector"
                        id="portfolio-select"
                        name="portfolio-select"
                        value={newPortfolioId}
                        onChange={handleChange}>
                        <option value={0}>{t('general.select')}</option>
                        {portfolios &&
                            portfolios.length > 0 &&
                            portfolios.map((p) => (
                                <option key={p.id} value={p.id}>
                                    {p.name}
                                </option>
                            ))}
                    </NativeSelect>
                </FormControl>
                {infoText && infoText.length > 0 && (
                    <Box sx={styles.info}>
                        <Alert severity="info">{infoText}</Alert>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="primary"
                    sx={styles.button}
                    disabled={newPortfolioId === props.currentPortfolioId || !newPortfolioId || processing}
                    name="btn-execute-change"
                    onClick={execute}
                    startIcon={processing ? <CircularProgress color={'secondary'} size={'1rem'} /> : null}>
                    {t('buttons.move')}
                </Button>
                <Button
                    variant="contained"
                    sx={styles.button}
                    name="btn-cancel"
                    disabled={processing}
                    onClick={cancel}>
                    {t('buttons.cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

ChangePortfolioDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    cancel: PropTypes.func.isRequired,
    changePortfolio: PropTypes.func.isRequired,
    currentPortfolioId: PropTypes.number.isRequired,
    portfolios: PropTypes.array.isRequired,
};
